import React, { useMemo } from 'react';

import { SxProps } from '@mui/material/styles';
import { green, red, purple, orange } from '@mui/material/colors';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorCircleIcon from '@mui/icons-material/Error';
import CancelCircleIcon from '@mui/icons-material/Cancel';

export type AnswerResultType = 'positive' | 'negative' | 'neutral' | 'none';

export interface AnswerResultIconProps {
  sx?: SxProps;
  type?: AnswerResultType;
  score?: number;
}

const AnswerResultIcon = ({ type: pType, score, sx = [] }: AnswerResultIconProps) => {
  const type = useMemo(() => {
    if (pType) return pType;

    if (score) {
      if (score > 0) return 'positive';
      if (score < 0) return 'negative';
      return 'neutral';
    }
    return 'none';
  }, [pType, score]);

  switch (type) {
    case 'positive':
      return <CheckCircleIcon sx={[{ color: green[500] }, ...(Array.isArray(sx) ? sx : [sx])]} />;
    case 'negative':
      return <CancelCircleIcon sx={[{ color: red[500] }, ...(Array.isArray(sx) ? sx : [sx])]} />;
    case 'neutral':
      return <CancelCircleIcon sx={[{ color: orange[500] }, ...(Array.isArray(sx) ? sx : [sx])]} />;
    case 'none':
      return <ErrorCircleIcon sx={[{ color: purple[500] }, ...(Array.isArray(sx) ? sx : [sx])]} />;
  }
};

export default AnswerResultIcon;
